import React from "react";
import { NavLink } from "react-router-dom";

const MortgageValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Mortgage Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Mortgage valuation is commonly required by the bank to confirm the
          property value before they can lend finance and use the residential
          property as security. Primus Agent Services have experience
          in providing mortgage valuation to most major banks over the last ten
          (10) years.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default MortgageValuationTab;
